<template>
    <h1>Coming Soon!</h1>
  </template>
  
  <script>
  export default {
    name: "EngineerDashboard",
    mounted(){
      this.$router.push({name: 'engineer.sites'})
    }
  }
  </script>